<!--查看详情-->
<template>
  <el-dialog :destroy-on-close="true"
             :title="selectDetail.title"
             append-to-body
             :visible.sync="showDialog"
             :before-close="cancel"
             class="detailDialog"
            >
    <el-form :label-width="maxLengthLabel*20+'px'">
      <slot name="content" v-bind="form.data">
        <div v-for="item in form.data">
          <div  v-if="isOpenHtml" v-viewer  v-html="item.value" class="detailHtml" style="overflow-x: auto"></div>
          <div v-else >
            <el-form-item v-if="isShowLabelTitle" :label="item.label">
              <el-input v-model="item.value" :type="item.inputType" readonly :autosize="{ minRows: 4}"></el-input>
            </el-form-item>
            <el-form-item v-else>
              <el-input v-model="item.value" :type="item.inputType" readonly :autosize="{ minRows: 4}"></el-input>
            </el-form-item>
          </div>

        </div>
      </slot>
    </el-form>
    <span style="color: #a4a2a2">{{ selectDetail.note }}</span>
    <span slot="footer" class="dialog-footer">
      <el-button @click="cancel">关 闭</el-button>
      </span>
  </el-dialog>
</template>

<script>
export default {
  name: "WLookDetail",
  props: {
    title: {
      default: ''
    },
    selectDetail: {
      default: () => ({})
    },
    showDialog: {
      default: false
    },
    isOpenHtml: {
      default: false
    },
    isShowLabelTitle:{
      default:true
    }
  },
  data() {
    return {
      form: {...this.selectDetail},
      maxLengthLabel: this.isShowLabelTitle?Math.max(...this.selectDetail.data.map(item => item.label.length)):0
    }
  },
  methods: {
    cancel() {
      this.$emit('update:showDialog')
    },
  }
}
</script>

<style scoped >
.detailHtml{
  border: #dadada 1px solid;
  padding: 10px;
}
.detailDialog /deep/ .el-dialog{
  min-width: 550px!important;
  width: 45%;
}
.viewer-container{
  z-index: 9999!important;
}
</style>
